import UserCompGrid from 'components/User/UserCompGrid'
import { useUser } from 'contexts/UserContext'
import useFetch from 'hooks/useFetch'
import { useToast } from 'hooks/useToast'
import { useEffect } from 'react'

export default function UserViewGrid() {
  const { showToast } = useToast()
  const { user } = useUser()

  // useFetch(): hook personalizado para realizar solicitudes GET, POST, PUT, DELETE
  const [fetchedUsers, fetchUsers] = useFetch()
  const [deletedUser, deleteUser] = useFetch()

  // CRUD: GET
  const handleRefresh = async () => {
    const apiCallGet = {
      url: 'users',
      method: 'GET',
      messageKo: '¡Error cargando usuarios!'
    }
    await fetchUsers(apiCallGet)
  }

  // Ejecutar GET
  useEffect(() => {
    handleRefresh()
  }, [])

  // CRUD: DELETE
  const handleDelete = async (id) => {
    const apiCallDelete = {
      url: `users/${user.id}/${id}`,
      method: 'DELETE'
    }
    await deleteUser(apiCallDelete)
  }

  // Mostrar mensaje API: DELETE (notificación de éxito o error)
  useEffect(() => {
    if (deletedUser.isCalled) {
      if (deletedUser.message) {
        showToast(deletedUser.message, 'success')
        handleRefresh()
      }

      if (deletedUser.error) {
        showToast(deletedUser.error, 'error')
      }
    }
  }, [deletedUser.loading])

  return (
    <UserCompGrid
      user={user}
      data={fetchedUsers?.data}
      handleDelete={handleDelete}
    />
  )
}
